"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _dropdown = _interopRequireDefault(require("./dropdown"));

var _dropdownButton = _interopRequireDefault(require("./dropdown-button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

_dropdown["default"].Button = _dropdownButton["default"];
var _default = _dropdown["default"];
exports["default"] = _default;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/dropdown/index.js
// module id = 249
// module chunks = 0